<template>
  <div class="page">
    <section class="container" v-if="activity">
      <pre>missingMin: {{ missingMin }}</pre>
      <pre>activity.IsPrivateTour: {{ activity.IsPrivateTour }}</pre>
      <pre>time.TotalAvailable: {{ time.TotalAvailable }}</pre>
      <pre>activity.CapacityTypeKey: {{ activity.CapacityTypeKey }} </pre>

      <code>views/LargeGuests.vue</code>
      <pre>time.TotalAvailable: {{ time.TotalAvailable }}</pre>
      <pre>totalActivityParticipants: {{ totalActivityParticipants }}</pre>

      <transition name="slide-vertical">
        <p
          class="bg-gray p-1 border_radius flex_start"
          v-if="packageParticipants && (activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3)"
        >
          Add a total of
          <strong>&nbsp;{{ packageParticipants }}</strong
          >{{
            activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3
              ? ""
              : activity.OverrideRateLabel
              ? totalParticipants == 1
                ? activity.RateLabelSingular
                : activity.RateLabelPlural
              : totalParticipants != 1
              ? "guests"
              : "guest"
          }}.
        </p>
      </transition>

      <transition name="slide-vertical">
        <p
          class="bg-gray p-1 border_radius flex_start"
          v-show="totalActivityParticipants <= time.TotalAvailable && activity.CapacityTypeKey != 2 && activity.CapacityTypeKey != 3"
        >
          Add up to
          <strong>&nbsp;{{ time.TotalAvailable }}&nbsp;</strong>
          {{
            activity.OverrideRateLabel
              ? totalActivityParticipants == 1
                ? activity.RateLabelSingular
                : activity.RateLabelPlural
              : totalActivityParticipants != 1
              ? "guests"
              : "guest"
          }}.
        </p>
      </transition>

      <p class="bg-gray p-1 border_radius flex_start" v-show="activity.IsPrivateTour">
        How many
        {{ activity.OverrideRateLabel ? activity.RateLabelPlural : "guests" }}
        will be a part of your private party?
      </p>

      <transition name="slide-vertical">
        <p
          class="bg-gray p-1 border_radius flex_start"
          :class="{
            'error shake-animation': totalActivityParticipants > time.TotalAvailable,
          }"
          v-show="totalActivityParticipants > time.TotalAvailable"
        >
          Add no more than
          <strong>&nbsp;{{ time.TotalAvailable }}&nbsp;</strong>
          guests.
        </p>
      </transition>

      <!-- <p
      class="bg-gray p-2 border_radius flex_start"
      v-show="totalActivityParticipants < activeProductDetails.Participants"
    >
      Add a total of
      <strong>&nbsp;{{activeProductDetails.Participants}}&nbsp;</strong>
      guests
      </p>-->

      <pre v-if="timeSlotRequirements">timeSlotRequirements: {{ timeSlotRequirements }}</pre>

      <guests-rate
        :isPackage="false"
        :totalActivityParticipants="totalActivityParticipants"
        :isPrivateTour="false"
        :packageParticipants="activeProductDetails.Participants"
        :disableAdd="disableAdd"
        v-for="(r, i) in timeRates"
        :rate="r"
        :durRates="'test987'"
        :activity="activity"
        :ultimateMaxPeople="time.TotalAvailable"
        :key="i + '-large-guests-times-rate-' + r.EntityHierarchyRateKey"
        @onDurationVacancyUpdate="calcRemainingDurationVacancies"
      />
    </section>

    <page-header :fixed="true" :undo="true">
      <h3 v-if="activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3">
        Select durations for this time
      </h3>
      <h3 v-else>
        Add
        {{ activity.OverrideRateLabel ? activity.RateLabelPlural : "guests" }}
        for this time
      </h3>

      <template v-slot:undo>
        <div class="back Cancel">
          <a @click.prevent="undo" class="text-blue chevron left" href>&nbsp;</a>
        </div>
      </template>
    </page-header>

    <page-footer v-if="activity">
      <template v-slot:text>
        <h4 v-if="activeProductDetails.PackageKey">
          {{ totalActivityParticipants }} of {{ packageParticipants }}
          {{ activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3 ? "selected" : "guests" }}
        </h4>
        <h4 v-else-if="activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3">{{ totalActivityParticipants }} selected</h4>
        <h4 v-else>
          {{ totalActivityParticipants }}
          {{
            activity.OverrideRateLabel
              ? totalActivityParticipants == 1
                ? activity.RateLabelSingular
                : activity.RateLabelPlural
              : totalActivityParticipants != 1
              ? "guests"
              : "guest"
          }}
        </h4>

        <span class="text-red shake-animation" v-if="totalActivityParticipants > time.TotalAvailable"
          >Too many {{ activity.OverrideRateLabel ? activity.RateLabelPlural : "guests" }}!</span
        >
        <small v-else>for {{ time.DisplayName }}</small>
        <small class="shake-animation text-red" v-if="totalActivityParticipants && missingMin"
          >"{{ missingMin.Name }}" requires minimum of&nbsp;{{ missingMinMin }}</small
        >
      </template>
      <template v-slot:button>
        <button
          style="min-width: 100px;"
          href="#"
          @click.prevent="largeGuestDone"
          :disabled="!enableDoneButton || missingMin"
          class="button blue ml-1 text-center"
          :class="{
            'scale-animation': enableDoneButton,
            button_loading: addToCartLoading,
          }"
        >
          Done
        </button>
      </template>
    </page-footer>

    <post-add-to-cart-modals
      :addToCartLoading="addToCartLoading"
      :modelErrorsModal="modelErrorsModal"
      @modelErrorsModalOk="modelErrorsModalOk"
      :takenTimesModal="takenTimesModal"
      @takenTimesModalOk="takenTimesModalOk"
      :overlappedActivitiesModal="overlappedActivitiesModal"
      @overlappedActivitiesModalNo="overlappedActivitiesModalNo"
      @overlappedActivitiesModalYes="overlappedActivitiesModalYes"
      :isPackage="activeProductDetails.PackageKey"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import PageFooter from "../components/PageFooter.vue";

import GuestsRate from "./GuestsRate.vue";

import PostAddToCartModals from "../components/PostAddToCartModals.vue";

import postTimeSelection from "../mixins/postTimeSelection.js";
import addToCart from "../mixins/addToCart.js";
import guestMixin from "../mixins/guestMixin.js";
//import { settings } from "cluster";

export default {
  name: "LargeGuests",
  data: function() {
    return {
      backupTime: null,
      backupTimeRates: [],
    };
  },
  props: ["IsLargeGroup"],
  components: {
    GuestsRate,
    PageFooter,
    PostAddToCartModals,
  },

  mixins: [postTimeSelection, guestMixin, addToCart],

  // beforeRouteLeave(to, from, next) {
  //   const answer = window.confirm(
  //     "Do you really want to leave? you have unsaved changes!"
  //   );
  //   if (answer) {
  //     next();
  //   } else {
  //     next(false);
  //   }
  // },

  // beforeCreate() {
  //   alert("beforeCreate");
  // },

  activated() {
    //alert("activated");
    //this.backupTime = JSON.parse(JSON.stringify(this.time));
    this.backupTimeRates = JSON.parse(JSON.stringify(this.timeRates));

    let el = document.querySelector(".product_details");
    el.scrollTop = 0;

    console.log("time", this.time);
    console.log("timeRates", this.time, this.timeRates);
  },

  // deactivated() {
  //   alert("deactivated");
  // },

  // beforeMount() {
  //   alert("beforeMount");
  // },

  // beforeUpdate() {
  //   alert("beforeUpdate");
  // },
  // updated() {
  //   alert("updated");
  // },

  // created() {
  //   alert("created");
  // },

  methods: {
    ...mapActions(["goToAddons"]),

    undo() {
      this.timeRates = this.backupTimeRates;
      setTimeout(() => {
        this.$router.go(-1);
      }, 250);
    },

    largeGuestDone() {
      // update the time.Requirements
      // what do I need to do next
      this.advancePostTimeSelection("largeGroupMode", this.time.Value, this.$route);
    },
    calcRemainingDurationVacancies(rate) {
      if (!rate.Duration) return;

      // map all current rate participants to their duration pool
      const durationPoolMap = new Map();
      this.timeRates.forEach((r) => {
        if (durationPoolMap.has(r.Duration)) {
          let durMapping = durationPoolMap.get(r.Duration);
          durMapping.count += r.Participants;
          durationPoolMap.set(r.Duration, durMapping);
        } else {
          let initialRateVacancy = this.backupTimeRates.find((btr) => btr.EntityHierarchyRateKey == r.EntityHierarchyRateKey).Vacancies; // initial rate vacancy pool
          durationPoolMap.set(r.Duration, {
            vacancies: initialRateVacancy,
            count: r.Participants,
          });
        }
      });

      // update rate vacancies based on current rate selection
      this.timeRates.forEach((r) => {
        let initialVacancy = durationPoolMap.get(r.Duration).vacancies; // starting vacancy

        let rateVacancy = initialVacancy - r.Participants; // vacancy minus participants

        let vacancyPoolMap = new Map();

        let durationOffset = Array.from(durationPoolMap).reduce((p, rvm) => {
          let duration = rvm[0];
          let mapping = rvm[1];
          if (duration == r.Duration) {
            // same duration different rate - same vacancy pool
            p += mapping.count - r.Participants;
          } else if (duration > r.Duration) {
            // higher duration always pulls from vacancy pool
            p += mapping.count;
          } else {
            // check if any lower duration rates are pulling from vacancy pool
            if (vacancyPoolMap.has(mapping.vacancies)) {
              let lowerMappingCount = vacancyPoolMap.get(mapping.vacancies);
              lowerMappingCount += mapping.count;
              vacancyPoolMap.set(mapping.vacancies, lowerMappingCount);
            } else {
              vacancyPoolMap.set(mapping.vacancies, mapping.count);
            }
          }
          return p;
        }, 0);

        let vacancyOffset = vacancyPoolMap.size
          ? Array.from(vacancyPoolMap).reduce((p, lvm) => {
              if (lvm[0] - lvm[1] < initialVacancy) {
                p += initialVacancy - (lvm[0] - lvm[1]);
              }
              return p;
            }, 0)
          : 0;

        r.Vacancies = rateVacancy - durationOffset - vacancyOffset;

        if (r.Vacancies < 0) r.Vacancies = 0; // no negative vacancies
      });
    },
    calculateMinParticipants(rate) {
      var isPrivate = this.activity.IsPrivateTour;
      var participants = rate.Participants;
      var min = rate.MinForPrivateTourOnly ? (isPrivate ? rate.MinParticipants : false) : rate.MinParticipants;
      if (rate.IsRequired) {
        return min ? min : 1;
      }
      return participants > 0 ? (min ? min : 0) : 0;
    },
  },

  watch: {},

  computed: {
    ...mapGetters(["activeProductDetails"]),

    missingMin() {
      if (this.timeRates) {
        return this.timeRates.find((rate) => {
          return rate.Participants < this.calculateMinParticipants(rate);
        });
      } else {
        return false;
      }
    },
    missingMinMin() {
      return this.calculateMinParticipants(this.missingMin);
    },

    activity() {
      if (this.activeProductDetails && this.activeProductDetails.Activities) {
        let find = this.activeProductDetails.Activities.find((act) => {
          return act.EntityHierarchyKey * 1 === this.$route.params.entityHierarchyKey * 1;
        });
        if (find) {
          //           console.log(find.Rates);
          //           console.log(find.TimesClone)
          return find;
        }
        return {};
      } else {
        return {};
      }
    },

    // activity() {
    //   if (this.activeProductDetails) {
    //     return this.activeProductDetails.Activities.find(act => {
    //       return (
    //         act.EntityHierarchyKey == this.$route.params.entityHierarchyKey
    //       );
    //     });
    //   }
    //   return false;
    // },

    enableDoneButton() {
      // if RateDuration and is a packge
      // package participant must match activity participants
      if ((this.activity.CapacityTypeKey == 2 || this.activity.CapacityTypeKey == 3) && this.activeProductDetails.PackageKey) {
        if (this.totalActivityParticipants != this.packageParticipants) {
          return false;
        }
      }

      if (this.totalActivityParticipants > 0 && this.totalActivityParticipants <= this.time.TotalAvailable) {
        return true;
      }

      return false;
    },

    totalActivityParticipants() {
      let t = 0;

      if (this.time.Rates) {
        this.time.Rates.forEach((ele) => {
          t = t + ele.Participants;
        });
      }

      return t;
    },

    packageParticipants() {
      return this.activeProductDetails && this.activeProductDetails.Participants;
    },

    timeId() {
      // essentially the time ID as time.Value
      return this.$route.params.timeId ? this.$route.params.timeId * 1 : false;
    },

    time() {
      if (this.activity && !this.activity.TimesClone) {
        console.warn("Missing this.activity.TimesClone");
      }
      //
      if (this.activity && this.activity.TimesClone) {
        let time = this.activity.TimesClone.find((ele) => {
          return ele.Value * 1 === this.timeId * 1;
        });

        return time ? time : { Rates: [] };
      }
      return false;
    }, // time

    timeRates: {
      get: function() {
        if (this.activity && !this.activity.TimesClone) {
          console.warn("Missing this.activity.TimesClone");
        }
        //
        if (this.activity && this.activity.TimesClone) {
          let time = this.activity.TimesClone.find((ele) => {
            return ele.Value * 1 == this.timeId * 1;
          });
          //           console.log(this.activity.TimesClone,time,time.Rates)
          return time ? time.Rates : [];
        }

        return false;
      },
      set: function(newValue) {
        const findTime = this.activity.TimesClone.find((ele) => {
          return ele.Value == this.timeId;
        });

        findTime.Rates = JSON.parse(JSON.stringify(newValue));
      },
    }, // time
  },
};
</script>

<style></style>
